import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
  userToken: {},
  loading: false,
};

const requestTokensStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const getTokenSignupSuccess = (state, action) => {
  return updateObject(state, {
    userToken: action.userToken,
    loading: false
  });
};

const getTokenConfirmAddTenantOrUserSuccess = (state, action) => {
    return updateObject(state, {
      userToken: action.userToken,
      loading: false
    });
  };

const requestTokensFail = (state, action) => {
  return updateObject(state, { loading: false });
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_TOKENS_START: return requestTokensStart(state, action);
    case actionTypes.GET_TOKEN_SIGNUP: return getTokenSignupSuccess(state, action);
    case actionTypes.REQUEST_TOKENS_FAIL: return requestTokensFail(state, action);
    case actionTypes.GET_TOKEN_CONFIRM_ADD_TENANT_OR_USER: return getTokenConfirmAddTenantOrUserSuccess(state, action);

    default: return state;
  }
};

export default reducer;